import type { SVGProps } from 'react';

const SvgNavigationForms = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}>
    <g fill={props.color}>
      <path d="M2.8 8.778c0-.4.313-.722.7-.722h7c.387 0 .7.323.7.722s-.313.722-.7.722h-7a.711.711 0 0 1-.7-.722zM3.5 4.556c-.387 0-.7.323-.7.722S3.113 6 3.5 6h7c.387 0 .7-.323.7-.722s-.313-.722-.7-.722z" />
      <path
        fillRule="evenodd"
        d="M0 2.667C0 1.47.94.5 2.1.5h9.8c1.16 0 2.1.97 2.1 2.167v8.666c0 1.197-.94 2.167-2.1 2.167H2.1c-1.16 0-2.1-.97-2.1-2.167zm2.1-.723c-.387 0-.7.324-.7.723v8.666c0 .4.313.723.7.723h9.8c.387 0 .7-.324.7-.723V2.667a.711.711 0 0 0-.7-.723z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export default SvgNavigationForms;
